module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "main"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top vale-page"
  }, [(!_vm.carregando && !_vm.habilitado) ? _c('div', {
    staticClass: "alert alert-warning mensagem-estado"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v("\n      Você não atende aos critérios para realizar a escolha do vale-alimentação.\n    ")]) : (!_vm.carregando && !_vm.periodoAberto) ? _c('div', {
    staticClass: "alert alert-info mensagem-estado"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v("\n      Aguarde o próximo período para escolha do vale-alimentação.\n    ")]) : (!_vm.carregando) ? [_c('div', {
    staticClass: "row cabecalho-row"
  }, [_c('div', {
    staticClass: "col-md-12 cabecalho-vale"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    class: _vm.badgeClass,
    attrs: {
      "title": _vm.badgeLabel
    }
  }, [_c('i', {
    class: _vm.badgeIcon
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.badgeLabel))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row cards-resumo"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card card-default card-info resumo-card"
  }, [_c('div', {
    staticClass: "card-content d-flex-center"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "resumo-conteudo"
  }, [_c('small', [_vm._v("Ano da competência")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.anoCompetencia))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card card-default card-info resumo-card"
  }, [_c('div', {
    staticClass: "card-content d-flex-center"
  }, [_c('span', {
    staticClass: "resumo-icone",
    style: ({
      color: _vm.statusColor
    })
  }, [_c('i', {
    class: _vm.statusIconClass
  })]), _vm._v(" "), _c('div', {
    staticClass: "resumo-conteudo"
  }, [_c('small', [_vm._v("Situação")]), _vm._v(" "), _c('strong', {
    style: ({
      color: _vm.statusColor
    })
  }, [_vm._v(_vm._s(_vm.statusLabel))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card card-default card-info resumo-card"
  }, [_c('div', {
    staticClass: "card-content d-flex-center"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "resumo-conteudo"
  }, [_c('small', [_vm._v("Data da escolha")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.dataEscolhaFormatada))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default escolha-card"
  }, [_c('div', {
    staticClass: "card-content escolha-card-content"
  }, [_c('div', {
    staticClass: "servidor-info"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "servidor-dados"
  }, [_c('small', [_vm._v("Nome do servidor")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.nomeServidor))])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), (!_vm.temEscolha && !_vm.modoEscolha) ? _c('div', {
    staticClass: "escolha-vazia"
  }, [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "icone": "fa-check",
      "rotulo": "ESCOLHER EMPRESA"
    },
    on: {
      "clicado": _vm.iniciarEscolha
    }
  })], 1) : [_c('div', {
    staticClass: "escolha-cabecalho"
  }, [_c('div', [_c('h5', {
    staticClass: "titulo-escolha"
  }, [_vm._v(_vm._s(_vm.temEscolha ? 'Sua escolha' : 'Escolha sua empresa'))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.somenteConsulta ? 'Esta escolha está disponível somente para consulta.' : 'Selecione a empresa desejada e salve para confirmar.'))])])]), _vm._v(" "), _c('div', {
    staticClass: "lista-empresas"
  }, _vm._l((_vm.empresasExibidas), function(empresa) {
    return _c('div', {
      key: empresa.id,
      staticClass: "empresa-item",
      class: _vm.classeItem(empresa.id)
    }, [_c('div', {
      staticClass: "empresa-conteudo"
    }, [_c('label', {
      staticClass: "radio-inline radio-empresa"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.empresaSelecionada),
        expression: "empresaSelecionada"
      }],
      attrs: {
        "type": "radio",
        "disabled": _vm.somenteConsulta
      },
      domProps: {
        "value": empresa.id,
        "checked": _vm._q(_vm.empresaSelecionada, empresa.id)
      },
      on: {
        "change": function($event) {
          _vm.empresaSelecionada = empresa.id
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "nome-empresa"
    }, [_vm._v(_vm._s(_vm.nomeDaEmpresa(empresa)))])]), _vm._v(" "), (empresa.temMaterial !== false) ? _c('a', {
      staticClass: "link-detalhes",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.abrirAnexoEmNovaAba(empresa.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o"
    }), _vm._v("\n                          Material informativo\n                          "), _c('i', {
      staticClass: "fa fa-external-link"
    })]) : _vm._e()])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "actions-footer"
  }, [(!_vm.somenteConsulta) ? _c('botao', {
    attrs: {
      "estilo": _vm.podeSalvar ? 'vazado-verde' : 'vazado-cinza',
      "icone": "salvar",
      "rotulo": "SALVAR",
      "disabled": !_vm.podeSalvar || _vm.salvando
    },
    on: {
      "clicado": _vm.salvar
    }
  }) : _vm._e(), _vm._v(" "), (_vm.temEscolha) ? _c('botao', {
    attrs: {
      "estilo": "vazado-verde",
      "icone": "fa-print",
      "rotulo": "IMPRIMIR PROTOCOLO",
      "disabled": _vm.imprimindo
    },
    on: {
      "clicado": _vm.imprimirProtocolo
    }
  }) : _vm._e()], 1)]], 2)])])])] : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titulo-vale"
  }, [_c('div', {
    staticClass: "icone-titulo"
  }, [_c('i', {
    staticClass: "fa fa-cutlery"
  })]), _vm._v(" "), _c('div', [_c('h4', [_vm._v("Escolher Vale-Alimentação")]), _vm._v(" "), _c('span', [_vm._v("Selecione a empresa de sua preferência.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "resumo-icone icone-verde"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "resumo-icone icone-verde"
  }, [_c('i', {
    staticClass: "fa fa-calendar-check-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "servidor-icone"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mensagem-fixa"
  }, [_c('p', [_c('span', {
    staticClass: "destaque"
  }, [_vm._v("Aviso:")]), _vm._v(" A votação é obrigatória. O servidor deverá escolher uma das empresas disponíveis.")]), _vm._v(" "), _c('p', {
    staticClass: "paragrafo"
  }, [_vm._v("Caso não seja registrada nenhuma opção, será considerada automaticamente a empresa que obtiver o maior número de votos.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "escolha-vazia-icone"
  }, [_c('i', {
    staticClass: "fa fa-cutlery"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "escolha-vazia-texto"
  }, [_c('h5', [_vm._v("Nenhuma empresa selecionada")]), _vm._v(" "), _c('p', [_vm._v("Escolha uma das empresas credenciadas para concluir sua opção de vale-alimentação.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aaf0924","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/vale-alimentacao/index.vue
// module id = jaCG
// module chunks = 5